export const create = {
  form: {
    code: 'Code',
    name: 'Name',
    type: 'Type',
    submit: 'Submit',
    select: 'Select',
    requireCode: 'Please input operator code',
    requireName: 'Please input operator name',
    requireType: 'Please input operator type',
  },
  pageHeader: {
    title: 'New Operator',
    back: 'Back',
  },
}
